const SITE_URL = import.meta.env.VITE_SITE_URL || 'https://offersshopping.com';

export default function VpnSeoJsonLd() {
  const breadcrumb = {
    '@context': 'https://schema.org',
    '@type': 'BreadcrumbList',
    itemListElement: [
      { '@type': 'ListItem', position: 1, name: 'Inicio', item: SITE_URL },
      { '@type': 'ListItem', position: 2, name: 'VPN AdGuard', item: `${SITE_URL}/vpn` },
    ],
  };

  const itemList = {
    '@context': 'https://schema.org',
    '@type': 'ItemList',
    name: 'VPN AdGuard Colombia - Digital Licence Store',
    url: `${SITE_URL}/vpn`,
    numberOfItems: 3,
    itemListElement: [
      {
        '@type': 'ListItem',
        position: 1,
        item: {
          '@type': 'Product',
          name: 'AdGuard VPN 1 Mes - 1 Dispositivo',
          description: 'AdGuard VPN para 1 dispositivo durante 1 mes. Navegación privada y segura.',
          url: `${SITE_URL}/vpn`,
          brand: { '@type': 'Brand', name: 'AdGuard' },
          offers: {
            '@type': 'Offer',
            priceCurrency: 'COP',
            price: '30500',
            priceValidUntil: '2025-12-31',
            availability: 'https://schema.org/InStock',
            url: `${SITE_URL}/vpn`,
            seller: { '@type': 'Organization', name: 'Digital Licence Store' },
          },
          aggregateRating: { '@type': 'AggregateRating', ratingValue: '5', reviewCount: '78', bestRating: '5' },
        },
      },
      {
        '@type': 'ListItem',
        position: 2,
        item: {
          '@type': 'Product',
          name: 'AdGuard VPN 1 Año - 5 Dispositivos',
          description: 'AdGuard VPN para 5 dispositivos durante 1 año. Precio mensual desde $21.950 COP.',
          url: `${SITE_URL}/vpn`,
          brand: { '@type': 'Brand', name: 'AdGuard' },
          offers: {
            '@type': 'Offer',
            priceCurrency: 'COP',
            price: '263400',
            priceValidUntil: '2025-12-31',
            availability: 'https://schema.org/InStock',
            url: `${SITE_URL}/vpn`,
            seller: { '@type': 'Organization', name: 'Digital Licence Store' },
          },
          aggregateRating: { '@type': 'AggregateRating', ratingValue: '5', reviewCount: '167', bestRating: '5' },
        },
      },
      {
        '@type': 'ListItem',
        position: 3,
        item: {
          '@type': 'Product',
          name: 'AdGuard VPN 2 Años - 10 Dispositivos',
          description: 'AdGuard VPN para 10 dispositivos durante 2 años. Mejor opción con 71% de descuento.',
          url: `${SITE_URL}/vpn`,
          brand: { '@type': 'Brand', name: 'AdGuard' },
          offers: {
            '@type': 'Offer',
            priceCurrency: 'COP',
            price: '358800',
            priceValidUntil: '2025-12-31',
            availability: 'https://schema.org/InStock',
            url: `${SITE_URL}/vpn`,
            seller: { '@type': 'Organization', name: 'Digital Licence Store' },
          },
          aggregateRating: { '@type': 'AggregateRating', ratingValue: '5', reviewCount: '283', bestRating: '5' },
        },
      },
    ],
  };

  const webpage = {
    '@context': 'https://schema.org',
    '@type': 'WebPage',
    name: 'AdGuard VPN Colombia - Hasta 77% Descuento | Digital Licence Store',
    description: 'Compra AdGuard VPN al mejor precio en Colombia. Planes desde 1 mes hasta 2 años para 1, 5 y 10 dispositivos. Descuentos hasta 77%.',
    url: `${SITE_URL}/vpn`,
    inLanguage: 'es-CO',
    isPartOf: { '@type': 'WebSite', name: 'Digital Licence Store', url: SITE_URL },
    breadcrumb: breadcrumb,
  };

  return (
    <>
      <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: JSON.stringify(itemList) }} />
      <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: JSON.stringify(webpage) }} />
    </>
  );
}
